import { AgButton } from 'src/components/ui';

export type DeferredRetryProps = { message: string; actionLabel: string; onRetry: () => unknown };

export function DeferredRetry({ message, actionLabel, onRetry }: DeferredRetryProps) {
  return (
    <div role="alert" className="flex items-center gap-2 text-14 text-red-text">
      <span>{message}</span>
      <AgButton variant="white" size="xs" onPress={() => void onRetry()}>
        {actionLabel}
      </AgButton>
    </div>
  );
}
